<template>
    <div class="normal-container">
        <div class="pb-5 lg:pb-8">
            <h2 class="mb-6 text-xl lg:mb-10 lg:!text-2xl">Mijn aankopen</h2>
            <div class="mb-7 lg:mb-10">
                <TabMenu :items="items" justify="justify-start" @value="activeTab = $event" />
            </div>
            <ShopwareAccountOrders :active-tab="activeTab" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    definePageMeta({ layout: 'account' });
    const items = ref(['Alles', 'Winkel', 'Online']);
    const activeTab = ref('Alles');

    const { isLoggedIn, refreshUser } = useUser();

    onMounted(async () => {
        await refreshUser({
            associations: {
                defaultBillingAddress: {
                    associations: {
                        country: {},
                        salutation: {},
                    },
                },
                defaultShippingAddress: {
                    associations: {
                        country: {},
                        salutation: {},
                    },
                },
            },
        });
    });
    // On client side, check if user is logged in otherwise redirect to /login
    onMounted(async () => {
        try {
            await refreshUser();
            if (!isLoggedIn.value) {
                window.location.href = '/login';
            }
        } catch (e) {
            console.error('Error on refresh user', e);
            window.location.href = '/login';
        }
    });
</script>
